import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {IndexTemplate} from '@github-ui/swp-core/layouts/contentful/IndexTemplate'
import {toIndexPage} from '@github-ui/swp-core/schemas/contentful/contentTypes/indexTemplate'
import resolveResponse from 'contentful-resolve-response'
import {toEntryCollection} from '../../lib/types/contentful'
import {toIndexPayload} from '../../lib/types/generic-payload'

export function IndexPage() {
  const {contentfulRawJsonResponse, additionalProps} = toIndexPayload(useRoutePayload<unknown>())
  const page = toIndexPage(toEntryCollection(resolveResponse(contentfulRawJsonResponse)).at(0))

  return <IndexTemplate page={page} additionalProps={additionalProps} />
}

try{ IndexPage.displayName ||= 'IndexPage' } catch {}